import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import api from "../../axiosConfig";

function AccountEdit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    code: "",
    name: "",
    type: "A",
    bxswitch: 0,

    // noi
    valuta_id: 1,
    on_menu: 0,
    menu_group: "",
    menu_order: 0,
    menu_label: "",
    genereaza_tva: 0,

    soldi_d: 0,
    soldi_c: 0,
    rulajd: 0,
    rulajc: 0,
    soldi_dv: 0,
    soldi_cv: 0,
    rulajdv: 0,
    rulajcv: 0,
  });

  useEffect(() => {
    api
      .get(`/accounts/${id}`)
      .then((res) => {
        const d = res.data || {};
        setForm((prev) => ({
          ...prev,
          ...d,
          // normalizări (să nu crape checkbox-urile)
          bxswitch: Number(d.bxswitch ?? 0),
          valuta_id: Number(d.valuta_id ?? d.bxvaluta_id ?? 1),
          on_menu: Number(d.on_menu ?? 0),
          menu_group: d.menu_group ?? "",
          menu_order: Number(d.menu_order ?? 0),
          menu_label: d.menu_label ?? "",
          genereaza_tva: Number(d.genereaza_tva ?? 0),
          soldi_d: Number(d.soldi_d ?? 0),
          soldi_c: Number(d.soldi_c ?? 0),
          rulajd: Number(d.rulajd ?? 0),
          rulajc: Number(d.rulajc ?? 0),
          soldi_dv: Number(d.soldi_dv ?? 0),
          soldi_cv: Number(d.soldi_cv ?? 0),
          rulajdv: Number(d.rulajdv ?? 0),
          rulajcv: Number(d.rulajcv ?? 0),
        }));
      })
      .catch((err) => {
        alert(
          "Eroare la încărcare: " + (err.response?.data?.detail || err.message),
        );
      });
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // checkbox-uri 0/1
    if (type === "checkbox") {
      setForm((prev) => ({ ...prev, [name]: checked ? 1 : 0 }));
      return;
    }

    // numeric
    if (type === "number") {
      setForm((prev) => ({
        ...prev,
        [name]: value === "" ? "" : Number(value),
      }));
      return;
    }

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handlePreluareSolduri = () => {
    api
      .post(`/accounts/${id}/preluare-solduri`)
      .then((res) => {
        const d = res.data;
        if (d.result === "pass") {
          setForm((prev) => ({
            ...prev,
            soldi_d: d.soldi_d,
            soldi_c: d.soldi_c,
            rulajd: d.rulajd,
            rulajc: d.rulajc,
            soldi_dv: d.soldi_dv,
            soldi_cv: d.soldi_cv,
            rulajdv: d.rulajdv,
            rulajcv: d.rulajcv,
          }));
          alert("Preluare solduri realizată cu succes. Nu uitați să salvați!");
        } else {
          alert("Eroare la preluare: " + (d.message || "Eroare necunoscută"));
        }
      })
      .catch((err) => {
        alert("Eroare: " + (err.response?.data?.detail || err.message));
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      ...form,
      bxswitch: Number(form.bxswitch ?? 0),
      valuta_id: Number(form.valuta_id ?? 1),
      on_menu: Number(form.on_menu ?? 0),
      menu_order: Number(form.menu_order ?? 0),
      genereaza_tva: Number(form.genereaza_tva ?? 0),
      menu_group: form.on_menu ? form.menu_group || null : null,
      menu_label: form.menu_label?.trim() ? form.menu_label.trim() : null,
      soldi_d: Number(form.soldi_d ?? 0),
      soldi_c: Number(form.soldi_c ?? 0),
      rulajd: Number(form.rulajd ?? 0),
      rulajc: Number(form.rulajc ?? 0),
      soldi_dv: Number(form.soldi_dv ?? 0),
      soldi_cv: Number(form.soldi_cv ?? 0),
      rulajdv: Number(form.rulajdv ?? 0),
      rulajcv: Number(form.rulajcv ?? 0),
    };

    api
      .put(`/accounts/${id}`, payload)
      .then(() => {
        alert("Cont actualizat cu succes");
        navigate("/accounts"); // mai logic decât "/"
      })
      .catch((err) =>
        alert(
          "Eroare la actualizare: " +
            (err.response?.data?.detail || err.message),
        ),
      );
  };

  return (
    <Container className="mt-4">
      <h3>Editare Cont #{id}</h3>

      <Form onSubmit={handleSubmit}>
        <Row className="g-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label>Cod *</Form.Label>
              <Form.Control
                name="code"
                value={form.code}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>

          <Col md={8}>
            <Form.Group>
              <Form.Label>Denumire *</Form.Label>
              <Form.Control
                name="name"
                value={form.name}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label>Tip *</Form.Label>
              <Form.Control
                name="type"
                value={form.type}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label>Valută</Form.Label>
              <Form.Select
                name="valuta_id"
                value={form.valuta_id}
                onChange={handleChange}
              >
                <option value={1}>RON</option>
                <option value={2}>EUR</option>
                <option value={3}>USD</option>
                <option value={4}>GBP</option>
              </Form.Select>
              <div className="text-muted" style={{ fontSize: 12 }}>
                RON=interni, EUR=UE, altă valută=afară UE
              </div>
            </Form.Group>
          </Col>

          <Col md={4}>
            <Form.Group>
              <Form.Label>bxswitch</Form.Label>
              <Form.Control
                type="number"
                name="bxswitch"
                value={form.bxswitch}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Check
              className="mt-2"
              type="checkbox"
              name="genereaza_tva"
              checked={!!form.genereaza_tva}
              onChange={handleChange}
              label="Generează TVA"
            />
          </Col>

          <Col md={6}>
            <Form.Check
              className="mt-2"
              type="checkbox"
              name="on_menu"
              checked={!!form.on_menu}
              onChange={handleChange}
              label="Apare în meniu (Financiar)"
            />
          </Col>

          {form.on_menu === 1 && (
            <>
              <Col md={4}>
                <Form.Group>
                  <Form.Label>Grup meniu</Form.Label>
                  <Form.Select
                    name="menu_group"
                    value={form.menu_group}
                    onChange={handleChange}
                    required
                  >
                    <option value="">— selectează —</option>
                    <option value="FURNIZORI">Furnizori</option>
                    <option value="CLIENTI">Clienți</option>
                    <option value="CASA">Casă</option>
                    <option value="BANCA">Bancă</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label>Ordine meniu</Form.Label>
                  <Form.Control
                    type="number"
                    name="menu_order"
                    value={form.menu_order}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label>Etichetă meniu (opțional)</Form.Label>
                  <Form.Control
                    name="menu_label"
                    value={form.menu_label}
                    onChange={handleChange}
                    placeholder="ex: Facturi furnizori interni"
                  />
                </Form.Group>
              </Col>
            </>
          )}
        </Row>

        <hr className="my-4" />
        <h5>Solduri de început</h5>
        <Row className="g-3 mb-3">
          <Col md={3}>
            <Form.Group>
              <Form.Label>Sold de început - Debit</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                name="soldi_d"
                value={form.soldi_d}
                onChange={handleChange}
                readOnly={form.bxswitch !== 0}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Sold de început - Credit</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                name="soldi_c"
                value={form.soldi_c}
                onChange={handleChange}
                readOnly={form.bxswitch !== 0}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Rulaj debitor inițial</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                name="rulajd"
                value={form.rulajd}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Rulaj creditor inițial</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                name="rulajc"
                value={form.rulajc}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="g-3 mb-3">
          <Col md={3}>
            <Form.Group>
              <Form.Label>Sold de început valută - Debit</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                name="soldi_dv"
                value={form.soldi_dv}
                onChange={handleChange}
                readOnly={form.bxswitch !== 0}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Sold de început valută - Credit</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                name="soldi_cv"
                value={form.soldi_cv}
                onChange={handleChange}
                readOnly={form.bxswitch !== 0}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Rulaj debitor valută inițial</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                name="rulajdv"
                value={form.rulajdv}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label>Rulaj creditor valută inițial</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                name="rulajcv"
                value={form.rulajcv}
                onChange={handleChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {(form.bxswitch === 1 || form.bxswitch === 11) && (
          <Row className="mb-3 g-2">
            <Col xs="auto">
              <Button variant="secondary" onClick={handlePreluareSolduri}>
                Preluare solduri din facturi
              </Button>
            </Col>
            <Col xs="auto">
              <Button
                variant="primary"
                onClick={() => {
                  if (form.bxswitch === 1) {
                    navigate(`/intrare?account_id=${id}&bxsoldint=1`);
                  } else {
                    navigate(`/iesire?account_id=${id}&bxsoldint=1`);
                  }
                }}
              >
                Facturi inițiale
              </Button>
            </Col>
          </Row>
        )}

        <div className="text-end mt-4">
          <Button type="submit" variant="primary" className="me-2">
            Salvează
          </Button>
          <Button variant="secondary" onClick={() => navigate(-1)}>
            Înapoi
          </Button>
        </div>
      </Form>
    </Container>
  );
}

export default AccountEdit;
